module.exports = __webpack_public_path__ + "static/media/orangeglove.9870abe2.svg";